import { defaultThemeVariables } from './default-theme-variables';

export const salesThemeVariables = {
  ...defaultThemeVariables
};
